import { req } from '../@api/request';
import LoanCommonInfoService from './LoanCommonInfo';

export default class LoanInfoService extends LoanCommonInfoService {
  static info = async (
    courcode: number,
    caseno: string,
    itemno: number,
    type: string,
    iidx: number,
    auctiononeidx: string,
  ) => {
    if (type === 'p') {
      const result = await req.get(
        `/ploan/info?courtcode=${courcode}&caseno=${caseno}&itemno=${itemno}&type=${type}&iidx=${auctiononeidx}`,
      );
      return result.data;
    }
    if (type === 'a') {
      const result = await req.get(
        `/loan/info?courtcode=${courcode}&caseno=${caseno}&itemno=${itemno}&type=${type}&iidx=${iidx}&auctiononeidx=${auctiononeidx}`,
      );
      return result.data;
    }
  };
  static saleItemList = async (iidx: number) => {
    const result = await req.get(`loan/saleItemLists?iidx=${iidx}`);
    // const result = await request.get(`loan/saleItemLists?iidx=${0}`);
    return result.data;
  };
  static saleItemStatus = async (iidx: number) => {
    const result = await req.get(`loan/saleItemStatus?iidx=${iidx}`);
    return result.data;
  };
  static registerationDoc = async (iidx: number, is_npl?: string) => {
    const result = await req.get(
      `loan/registerationDoc?iidx=${iidx}&is_npl=${is_npl}`,
    );
    return result.data;
  };
  static pauction = async (iidx: number) => {
    const result = await req.get(`loan/pauction?iidx=${iidx}`);
    return result.data;
  };
  static calenderStatus = async (date: string, court: string) => {
    const result = await req.get(
      `loan/calendar/stat?date=${date}&court=${court}`,
    );
    return result.data;
  };
  static calendar = async (
    court: string,
    court2: string,
    saleDate: string,
    status: string,
    sort: string,
    limit: number,
    offset: number,
  ) => {
    const result = await req.get(
      `loan/calendar?court=${court}&court2=${court2}&saleDate=${saleDate}&status=${status}&sort=${sort}&limit=${limit}&offset=${offset}`,
    );
    return result.data;
  };
  static complexInfo = async (type: string, idx: number) => {
    const result = await req.get(`loan/detail/complex/${type}/${idx}`);
    return result.data;
  };
  static courtDetail = async (iidx: number) => {
    const result = await req.get(`loan/detail/court?iidx=${iidx}`);
    return result.data;
  };
  static list = async (
    type: string,
    isCourtOrRegion: string,
    court: string,
    region: string,
    search: string,
    search2: string,
    search3: string,
    totalCategory: string,
    minappraisedValue: number,
    maxappraisedValue: number,
    minBidPrice: number,
    maxBidPrice: number,
    minconstructArea: number,
    maxconstructArea: number,
    minlandArea: number,
    maxlandArea: number,
    minSaleDate: string,
    maxSaleDate: string,
    minApprovalDate: string,
    maxApprovalDate: string,
    bidno: string,
    bidStatus: string,
    specialItemCond: string,
    specialItem: string,
    zoning: string,
    asset: string,
    is_npl: string,
    npl_holder: string,
    sort: string,
    limit: number,
    offset: number,
  ) => {
    const result = await req.get(
      `/loan/list?type=${type}&isCourtOrRegion=${isCourtOrRegion}&court=${court}&region=${region}&search=${search}&search2=${search2} &search3=${search3}
        &totalCategory=${totalCategory}&minappraisedValue=${minappraisedValue}&maxappraisedValue=${maxappraisedValue}&minBidPrice=${minBidPrice}&maxBidPrice=${maxBidPrice}
        &minconstructArea=${minconstructArea}&maxconstructArea=${maxconstructArea}&minlandArea=${minlandArea}&maxlandArea=${maxlandArea}&minSaleDate=${minSaleDate}
        &maxSaleDate=${maxSaleDate}&minApprovalDate=${minApprovalDate}&maxApprovalDate=${maxApprovalDate}&bidno=${bidno}&bidStatus=${bidStatus}&specialItemCond=${specialItemCond}&specialItem=${specialItem}&zoning=${zoning}&is_npl=${is_npl}&npl_holder=${npl_holder}&asset=${asset}&sort=${sort}&limit=${limit}&offset=${offset}`,
    );
    return result.data;
  };
}
